import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "change-skill-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "change-skill-modal-label"
  }, " Change worker skill "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "fs-4 fw-bold mb-3" }
const _hoisted_8 = { class: "mt-6 mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3 d-flex align-items-center justify-content-center"
}
const _hoisted_10 = { class: "badge badge-success rounded-pill width-fit-content" }
const _hoisted_11 = { class: "badge badge-success rounded-pill width-fit-content" }
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_BookUserBox = _resolveComponent("BookUserBox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_IconRightArrow = _resolveComponent("IconRightArrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.payload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, " Shift - " + _toDisplayString(_ctx.handleShiftLabel), 1),
                    _createVNode(_component_BookUserBox, {
                      userData: _ctx.payload.application.assignee
                    }, null, 8, ["userData"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.selectedSlot,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSlot) = $event)),
                        clearable: "",
                        size: "large",
                        placeholder: "Select position",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleSlots, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.shift_slot_id,
                              label: item.skill.name,
                              value: item.shift_slot_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (_ctx.selectedSlot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.skillsUI.currentSkill), 1),
                          _createVNode(_component_IconRightArrow, { class: "mx-3" }),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.skillsUI.selectedSkill), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSaveChanges && _ctx.handleSaveChanges(...args))),
            disabled: _ctx.isSaving
          }, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
              : _createCommentVNode("", true),
            _hoisted_16
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}